import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const SAVINGS = buildModuleApi({
    prefix: "SAVINGS",
    uri: "savings",
    withExtra: false,
    exclude: ["LIST", "CREATE", "UPDATE", "REMOVE", "DETAIL", "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    extraActions: {
        ACCOUNT_LIST: { suffix: "/accounts" },
        ACCOUNT_CREATE: { suffix: "/accounts" },
        ACCOUNT_UPDATE: { suffix: "/accounts" },
        ACCOUNT_REMOVE: { suffix: "/accounts" },
        ACCOUNT_ARCHIVE_LIST: { suffix: "/accounts/archived/list" },
        ACCOUNT_ARCHIVE: { suffix: "/accounts/:id/archive" },
        ACCOUNT_RESTORE: { suffix: "/accounts/:id/restore" },
        ACCOUNT_REVEAL: { suffix: "/accounts/reveal" },
        TRANSACTION_LIST: { suffix: "/transactions" },
        TRANSACTION_CREATE: { suffix: "/transactions" },
        TRANSACTION_UPDATE: { suffix: "/transactions" },
        TRANSACTION_REMOVE: { suffix: "/transactions" },
        TRANSACTION_ARCHIVE_LIST: { suffix: "/transactions/archived/list" },
        TRANSACTION_ARCHIVE: { suffix: "/transactions/:id/archive" },
        TRANSACTION_RESTORE: { suffix: "/transactions/:id/restore" },
        GOAL_LIST: { suffix: "/goals" },
        GOAL_CREATE: { suffix: "/goals" },
        GOAL_UPDATE: { suffix: "/goals" },
        GOAL_REMOVE: { suffix: "/goals" },
        GOAL_ARCHIVE_LIST: { suffix: "/goals/archived/list" },
        GOAL_ARCHIVE: { suffix: "/goals/:id/archive" },
        GOAL_RESTORE: { suffix: "/goals/:id/restore" },
        GOAL_MOVEMENT_CREATE: { suffix: "/goal-movements" },
        GOAL_MOVEMENT_REMOVE: { suffix: "/goal-movements" },
        GOAL_MOVEMENT_ARCHIVE_LIST: { suffix: "/goal-movements/archived/list" },
        GOAL_MOVEMENT_ARCHIVE: { suffix: "/goal-movements/:id/archive" },
        GOAL_MOVEMENT_RESTORE: { suffix: "/goal-movements/:id/restore" },
        BUDGET_LIST: { suffix: "/budgets" },
        BUDGET_CREATE: { suffix: "/budgets" },
        BUDGET_UPDATE: { suffix: "/budgets" },
        BUDGET_REMOVE: { suffix: "/budgets" },
        BUDGET_ARCHIVE_LIST: { suffix: "/budgets/archived/list" },
        BUDGET_ARCHIVE: { suffix: "/budgets/:id/archive" },
        BUDGET_RESTORE: { suffix: "/budgets/:id/restore" },
    },
});

export const SAVINGS_API = SAVINGS.API;
export const SAVINGS_CONSTANTS = SAVINGS.CONSTANTS;
export const SAVINGS_ENDPOINTS = SAVINGS.ENDPOINTS;
